import React, { useEffect, useRef, useState } from 'react'
import { BASE_FLAG_URL, PLACEHOLDER_URL } from './constants'
import styles from './index.module.css'

interface FlagProps {
  countryCode: string
}

export default function Flag({ countryCode }: FlagProps) {
  const imgRef = useRef<HTMLImageElement>(null)
  const [imgSrc, setImgSrc] = useState(`${BASE_FLAG_URL}${countryCode}.svg`)

  useEffect(() => {
    const img = imgRef.current
    if (!img) return

    if (img.complete && img.naturalWidth === 0) {
      setImgSrc(PLACEHOLDER_URL)
    }
  }, [])

  return (
    <img
      ref={imgRef}
      className={styles.flag}
      src={imgSrc}
      alt={countryCode}
      aria-label={countryCode}
      onError={e => {
        const target = e.target as HTMLImageElement
        target.onerror = null
        target.src = PLACEHOLDER_URL
        target.alt = countryCode
        target.setAttribute('aria-label', countryCode)
      }}
    />
  )
}
